<template>
  <div class="block-cntr">
    <div class="block-title-cntr">
      <h5 style="font-weight: bold">{{ btitle }}</h5>
      <!-- <span class="">lable</span> -->
      <div class="block-tools-cntr">
        <a class="collapse-link" @click="collapseBlock()">
          <i class="fa fa-chevron-up" :class="{'arrowq-active': collapseBlockFlag}"></i>
        </a>
        <a class="close-link" v-show="closeButton">
          <i class="fa fa-times"></i>
        </a>
      </div>
    </div>
    <div class="block-content-cntr" v-show="collapseBlockFlag">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "blockCntr",

  data() {
    return {
      collapseBlockFlag: true,
    }
  },
  props: {
    btitle: String,
    closeButton: Boolean,
    collapseStatus: String,
  },
  created() {
    this.collapseFlagInit()
  },
  methods: {
    collapseBlock() {
      this.collapseBlockFlag
        ? (this.collapseBlockFlag = false)
        : (this.collapseBlockFlag = true)
    },
    collapseFlagInit() {
      if (this.collapseStatus === "close") {
        this.collapseBlockFlag = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.block-cntr {
  clear: both;
  margin-bottom: 25px;
  margin-top: 0;
  padding: 0;
}
.block-title-cntr {
  background-color: #fff;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 3px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}
.block-title-cntr h5 {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  display: inline-block;
  font-size: 15px;
  color: #8f9294;
  margin: 0 0 7px;
  padding: 0;
  text-overflow: ellipsis;
  float: left;
}
.block-tools-cntr {
  display: block;
  float: none;
  margin-top: 0;
  position: relative;
  padding: 0;
  text-align: right;
}
.block-tools-cntr a {
  cursor: pointer;
  margin-left: 5px;
  color: #c4c4c4;
}
.block-content-cntr {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px 0;
  height: 100%;
}
.arrowq-active {
  transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  /* IE 9 */
  -moz-transform: rotate(180deg);
  /* Firefox */
  -webkit-transform: rotate(180deg);
  /* Safari and Chrome */
  -o-transform: rotate(180deg);
  /* Opera */
}
</style>
 
